import { Text } from "@mantine/core";
import type { EEGVersionDetailed } from "../../../../../types/api.types";
import { CustomFormFieldWrapper } from "../../../../BuildingBlocks/Forms/MantineFormFields/CustomFormFieldWrapper/CustomFormFieldWrapper";
import { getEegStundenregelLabel } from "../../../../EEGAnlage/utils/getEegStundenregelLabel";

interface EegStundenregelFieldProps {
  eegVersion?: EEGVersionDetailed | null;
  appliedP51Rule?: string | null;
}

export function EegStundenregelField({
  eegVersion,
  appliedP51Rule
}: EegStundenregelFieldProps) {
  const value = getEegStundenregelLabel(eegVersion, appliedP51Rule);

  return (
    <CustomFormFieldWrapper label="Angewandtes EEG und § 51 EEG - Negative Stunden Regelung">
      <Text c={value ? undefined : "dimmed"}>{value ?? "–"}</Text>
    </CustomFormFieldWrapper>
  );
}
